import { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Alert, Box, Snackbar } from "@mui/material";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import HeaderParking from "./components/HeaderParking";
import TableParking from "./components/TableParking";
import { useParking } from "./hooks/useParking";
import { parkingStats, parkingView } from "./model/parkingModel";
export function ParkingContent({ controller }) {
  const [notification, setNotification] = useState(null);
  const [activeView, setActiveView] = useState("all");
  const {
    comercios,
    todosComercios,
    loading,
    error,
    warning,
    filtros,
    tiposComercioUnicos,
    lastUpdated,
    refreshData,
    setFiltro,
    clearFilters,
  } = controller;
  const stats = useMemo(
    () => parkingStats(parkingView(comercios, activeView)),
    [comercios, activeView]
  );
  const refresh = async () => {
    const result = await refreshData();
    setNotification(
      result.success
        ? {
            severity: result.warning ? "warning" : "success",
            message: result.warning
              ? "Terminales actualizadas; el reporte de ciclos no está disponible."
              : "Datos actualizados correctamente",
          }
        : { severity: "error", message: result.error || "No se pudieron actualizar los datos" }
    );
  };
  return (
    <Box sx={{ py: 3 }}>
      <HeaderParking
        onRefresh={refresh}
        loading={loading}
        filtros={filtros}
        onFiltroChange={setFiltro}
        onClearFilters={clearFilters}
        tiposComercioUnicos={tiposComercioUnicos}
        stats={stats}
        total={todosComercios.length}
        lastUpdated={lastUpdated}
      />
      <TableParking
        activeView={activeView}
        onViewChange={setActiveView}
        comercios={comercios}
        loading={loading}
        error={error}
        warning={warning}
        onRefresh={refresh}
        resetKey={JSON.stringify(filtros)}
      />
      <Snackbar
        open={Boolean(notification)}
        autoHideDuration={5000}
        onClose={() => setNotification(null)}
      >
        <Alert severity={notification?.severity || "info"} onClose={() => setNotification(null)}>
          {notification?.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
ParkingContent.propTypes = { controller: PropTypes.object.isRequired };
export default function Parking() {
  const controller = useParking();
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ParkingContent controller={controller} />
    </DashboardLayout>
  );
}
